'use client';

import React from 'react';

import { TasticProps } from '../types';
import PastOrder from 'components/commercetools-ui/organisms/past-order';
import { useCheckPathAndHash } from 'components/commercetools-ui/organisms/utils';
import { TabsPath } from 'components/commercetools-ui/organisms/account/types/types';

const PastOrdersTastic = ({ data }: TasticProps<any>) => {
  const shouldDisplayThisTastic = useCheckPathAndHash('/account', TabsPath.MY_ACCOUNT);

  if (!shouldDisplayThisTastic) {
    return null;
  }

  return <PastOrder {...data} />;
};

export default PastOrdersTastic;
